import { render, staticRenderFns } from "./ProjectFileFrame.vue?vue&type=template&id=ed46e8bc&scoped=true&lang=pug&"
import script from "./ProjectFileFrame.vue?vue&type=script&lang=js&"
export * from "./ProjectFileFrame.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFileFrame.vue?vue&type=style&index=0&id=ed46e8bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed46e8bc",
  null
  
)

export default component.exports